<div [class.required]="required()">
    <app-label [label]="label()" customCss="text-sm text-gray-800" [required]="required() ? '*' : ''" />
    <div class="relative flex flex-row items-center w-full">
        <input
            #passwordInput
            [type]="checkbox.checked ? 'text' : 'password'"
            [disabled]="disabled()"
            class="w-full px-4 py-2 text-sm border border-gray-300 outline-none validation-indicator rounded-xl hover:focus-within:border-primary hover:border-primary-300 focus-within:border-primary"
            autocomplete="current-password"
            [placeholder]="placeholder() ?? ''"
            [(ngModel)]="value"
            [minlength]="min()"
        />
        <lepi-icon
            [name]="checkbox.checked ? 'mdi:eye' : 'mdi:eye-off'"
            class="absolute right-0 block mr-4 duration-300 ease-in-out bg-gray-400 cursor-pointer md:size-5 size-4"
            (click)="checkbox.checked = !checkbox.checked"
        />
        <input #checkbox type="checkbox" hidden />
    </div>
    @if (errorMessage(); as error) {
        <p class="text-sm text-red-500">{{ error }}</p>
    }
</div>
